import { useState, useEffect } from 'react'
import McDataServices from '../../services/McDataServices'
import { useGlobalStoreData } from '../../store/globalStore'

export const useCountries = () => {
  const [countries, setCountries] = useState([])
  const [loading, setLoading] = useState(false)

  const languageGSD = useGlobalStoreData.language()

  const fetchCountries = async () => {
    setLoading(true)
    try {
      const result = await McDataServices.getCountries({
        search_countries: 'false',
        user_countries: 'true'
      })
      setCountries(result.user_countries)
    } catch (error) {
      console.error('Failed to fetch countries:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCountries()
  }, [languageGSD])

  return { countries, loading, refetch: fetchCountries }
}
